import { ArrowRight, Calculator, Compass, FileCheck2, FileText, Globe2, Home as HomeIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { useLanguage } from "@/reusable_sections/Header";
export default function ServicesGrid() {
  const {
    lang
  } = useLanguage();
  const content = {
    en: {
      eyebrow: "§ 03 — OUR SERVICES",
      heading: "Comprehensive Cross-Border Know-How & Practice Areas",
      subtitle: "Structured solutions for international consulting, document preparation, and certified dispute resolution across Florida and Haitian jurisdictions.",
      learnMore: "Learn more",
      secondaryLink: "Remote Online Notary (RON)",
      services: [{
        id: "mediation",
        title: "Family & Divorce Mediation",
        description: "Florida Supreme Court certified family mediation for domestic, divorce, and parenting disputes seeking neutral, collaborative resolution.",
        to: "/FamilyMediationServicesPage",
        icon: "Compass"
      }, {
        id: "foreign-legal",
        title: "Foreign Legal Consulting (Haitian Law)",
        description: "Specialized consulting on Haitian civil law, commercial matters, succession, and bilateral regulatory compliance.",
        to: "/ForeignLegalConsultingPage",
        icon: "Globe2"
      }, {
        id: "immigration",
        title: "Immigration Document Preparation",
        description: "Assistance with administrative immigration document preparation, filings, and family petitions as a non-lawyer document preparer.",
        to: "/ImmigrationServicesPage",
        icon: "FileText"
      }, {
        id: "tax",
        title: "Tax Preparation",
        description: "Professional personal and corporate tax preparation, cross-border filing guidance, and compliance services.",
        to: "/TaxPreparationPage",
        icon: "Calculator"
      }, {
        id: "real-estate",
        title: "Real Estate Services",
        description: "Advisory and procedural support for property transactions, title verification inquiries, and cross-border real estate assets.",
        to: "/RealEstateServicesPage",
        icon: "HomeIcon"
      }, {
        id: "translation-notary",
        title: "Translation & Notary",
        description: "Certified multi-language document translation (English, French, Haitian Creole) accompanied by secure Remote Online Notary services.",
        to: "/CertifiedTranslationServicesPage",
        secondaryTo: "/RemoteOnlineNotaryPage",
        icon: "FileCheck2"
      }]
    },
    fr: {
      eyebrow: "§ 03 — NOS SERVICES",
      heading: "Savoir-faire transfrontalier et domaines d'intervention",
      subtitle: "Solutions structurées pour le conseil international, la préparation documentaire et la médiation certifiée entre la Floride et Haïti.",
      learnMore: "En savoir plus",
      secondaryLink: "Notaire en ligne à distance (RON)",
      services: [{
        id: "mediation",
        title: "Médiation Familiale & de Divorce",
        description: "Médiation familiale certifiée par la Cour Suprême de Floride pour les litiges domestiques, de divorce et parentaux par voie amiable.",
        to: "/FamilyMediationServicesPage",
        icon: "Compass"
      }, {
        id: "foreign-legal",
        title: "Consultation Juridique Étrangère (Droit Haïtien)",
        description: "Conseil spécialisé en droit civil haïtien, affaires commerciales, successions et conformité réglementaire bilatérale.",
        to: "/ForeignLegalConsultingPage",
        icon: "Globe2"
      }, {
        id: "immigration",
        title: "Préparation de Documents d'Immigration",
        description: "Assistance à la préparation administrative des dossiers d'immigration et requêtes familiales en qualité de préparateur agréé non-avocat.",
        to: "/ImmigrationServicesPage",
        icon: "FileText"
      }, {
        id: "tax",
        title: "Préparation Fiscale",
        description: "Préparation professionnelle des déclarations de revenus des particuliers et sociétés, conformité fiscale et déclarations transfrontalières.",
        to: "/TaxPreparationPage",
        icon: "Calculator"
      }, {
        id: "real-estate",
        title: "Services Immobiliers",
        description: "Accompagnement procédural pour transactions de biens, vérifications de titres et gestion d'actifs immobiliers transfrontaliers.",
        to: "/RealEstateServicesPage",
        icon: "HomeIcon"
      }, {
        id: "translation-notary",
        title: "Traduction & Notariat",
        description: "Traduction certifiée de documents (anglais, français, créole haïtien) combinée aux services de notariat en ligne à distance.",
        to: "/CertifiedTranslationServicesPage",
        secondaryTo: "/RemoteOnlineNotaryPage",
        icon: "FileCheck2"
      }]
    },
    ht: {
      eyebrow: "§ 03 — SÈVIS NOU YO",
      heading: "Konesans Transfontyè ak Domèn Sèvis Nou Yo",
      subtitle: "Solisyon estriktire pou konsiltasyon entènasyonal, preparasyon dokiman, ak rezolisyon konfli sètifye nan jiridiksyon Florid ak Ayiti.",
      learnMore: "Aprann plis",
      secondaryLink: "Notè an Liy a Distans (RON)",
      services: [{
        id: "mediation",
        title: "Mediyasyon Fanmi",
        description: "Mediyasyon fanmi sètifye pa Tribinal Siprèm Florid pou diskisyon fanmi, divòs, ak aranjman paran nan lapè ak antant.",
        to: "/FamilyMediationServicesPage",
        icon: "Compass"
      }, {
        id: "foreign-legal",
        title: "Konsiltasyon Legal Etranje (Lwa Ayisyen)",
        description: "Konsiltasyon espesyalize sou kòd sivil ayisyen, zafè komèsyal, siksesyon, ak konfòmite regilasyon bilateral.",
        to: "/ForeignLegalConsultingPage",
        icon: "Globe2"
      }, {
        id: "immigration",
        title: "Preparasyon Dokiman Imigrasyon",
        description: "Sipò nan preparasyon administratif dokiman imigrasyon ak petisyon fanmi kòm preparatè dokiman ki pa avoka.",
        to: "/ImmigrationServicesPage",
        icon: "FileText"
      }, {
        id: "tax",
        title: "Preparasyon Taks",
        description: "Preparasyon pwofesyonèl taks pou moun ak biznis, konsèy sou deklarasyon transfontyè, ak sèvis konfòmite fiskal.",
        to: "/TaxPreparationPage",
        icon: "Calculator"
      }, {
        id: "real-estate",
        title: "Sèvis Imobilye",
        description: "Sipò ak konsèy pwosedirèl pou tranzaksyon byen imobilye, verifikasyon tit, ak jesyon byen transfontyè.",
        to: "/RealEstateServicesPage",
        icon: "HomeIcon"
      }, {
        id: "translation-notary",
        title: "Tradiksyon & Notè",
        description: "Tradiksyon sètifye dokiman (Anglè, Franse, Kreyòl Ayisyen) ansanm ak sèvis notè an liy a distans (RON) ki sekirize.",
        to: "/CertifiedTranslationServicesPage",
        secondaryTo: "/RemoteOnlineNotaryPage",
        icon: "FileCheck2"
      }]
    }
  };
  const t = content[lang as "en" | "fr" | "ht"] || content.en;
  const renderIcon = (name: string) => {
    switch (name) {
      case "Compass":
        return <Compass className="size-6 text-primary" strokeWidth={1.5} />;
      case "Globe2":
        return <Globe2 className="size-6 text-primary" strokeWidth={1.5} />;
      case "FileText":
        return <FileText className="size-6 text-primary" strokeWidth={1.5} />;
      case "Calculator":
        return <Calculator className="size-6 text-primary" strokeWidth={1.5} />;
      case "HomeIcon":
        return <HomeIcon className="size-6 text-primary" strokeWidth={1.5} />;
      case "FileCheck2":
        return <FileCheck2 className="size-6 text-primary" strokeWidth={1.5} />;
      default:
        return <Compass className="size-6 text-primary" strokeWidth={1.5} />;
    }
  };
  return <section data-section-id="services-grid" id="services-grid" className="dark bg-background text-foreground py-24 md:py-32 border-b border-border">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-6 font-mono text-xs tracking-[0.2em] text-primary">
          <span>{t.eyebrow}</span>
        </div>

        {/* Section Heading & Subtitle */}
        <div className="max-w-3xl mb-14">
          <h2 className="font-serif font-normal text-3xl sm:text-4xl md:text-5xl leading-[1.1] text-foreground mb-4" style={{
          letterSpacing: "-0.02em"
        }}>
            {t.heading}
          </h2>
          <p className="font-sans text-base sm:text-lg text-muted-foreground leading-relaxed">
            {t.subtitle}
          </p>
        </div>

        {/* 6 Cards Grid: 1 col mobile, 2 col tablet, 3 col desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {t.services.map((service, idx) => <Card key={service.id} data-index={idx} className="rounded-lg border border-border bg-card/60 hover:bg-card hover:border-primary/50 transition-colors duration-300 p-7 flex flex-col justify-between">
              <div>
                <div className="size-12 rounded-lg bg-primary/10 border border-primary/30 flex items-center justify-center mb-6">
                  {renderIcon(service.icon)}
                </div>

                <h3 className="font-serif text-xl sm:text-2xl font-normal text-card-foreground mb-3 leading-snug">
                  {service.title}
                </h3>

                <p className="font-sans text-sm sm:text-base text-muted-foreground leading-relaxed mb-6">
                  {service.description}
                </p>
              </div>

              <div className="pt-4 border-t border-border/60 flex flex-col gap-2">
                <Link to={service.to} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-primary hover:text-primary/80 transition-colors duration-200 group">
                  <span>{t.learnMore}</span>
                  <ArrowRight className="size-3.5 transition-transform duration-200 group-hover:translate-x-1" strokeWidth={1.5} />
                </Link>

                {service.secondaryTo && <Link to={service.secondaryTo} className="inline-flex items-center gap-1.5 font-mono text-[11px] text-muted-foreground hover:text-foreground transition-colors duration-200 pt-1">
                    <span className="text-primary font-bold">›</span>
                    <span className="underline underline-offset-4 decoration-border hover:decoration-foreground">
                      {t.secondaryLink}
                    </span>
                  </Link>}
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}